import { render, staticRenderFns } from "./Alpha.vue?vue&type=template&id=791891ee&"
import script from "./Alpha.vue?vue&type=script&lang=js&"
export * from "./Alpha.vue?vue&type=script&lang=js&"
import style0 from "./Alpha.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports